<div class="file-upload-container">
  <h6 class="upload-head">Upload documents and extract text quickly</h6>
  <p>
    <span class="sub-head">Required Documents: </span><span class="sub-text">Passport, Resume</span>
  </p>
  <p><span class="sub-head">Upload: </span><span class="sub-text">PDF, JPG, JPEG</span></p>
  <div class="content-container">
    <div class="upload-box">
      <app-file-upload style="width: 100%" [isWizard]="true" [isImmigrationWizardIndividualDetails]="true"
        [configurations]="documentFileUploadConfigurations" (filesDataChange)="onFilesDataChange($event)"
        (fileCategoryChange)="onFileCategoryChange($event)"></app-file-upload>
    </div>
    <div class="preview-container">
      <p><img class="preview-img" alt="Preview" src="../../../../assets/images/details_default.png" /></p>
      <!-- <button type="button" [disabled]="!(documentFileUploadConfigurations?.listUploadedFiles?.length)"
        class="btn btn-primary mr-3 px-2" (click)="convertUpload()">Extract Data</button>
      <i class="info-icon fa fa-info-circle" pTooltip="Extract data from the latest uploaded document."></i> -->
    </div>
  </div>
  <div class="container-fluid" *ngIf="documentFileUploadConfigurations">
    <div class="row">
      <div class="col-12">
        <div class="pt-2" *ngIf="documentFileUploadConfigurations?.listUploadedFiles.length > 0"
          style="margin-bottom: 40px">
          <h5 class="heading">List of Uploaded Documents</h5>
          <p-table [value]="documentFileUploadConfigurations.listUploadedFiles" [paginator]="true" [rows]="10">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">Document Name</th>
                <th scope="col">Document Type</th>
                <th scope="col">Size</th>
                <th scope="col" class="text-center">
                  Actions
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td>
                  <strong><a style="cursor: pointer" (click)="openDoc(item)">{{ item.fileName }}</a></strong>
                </td>
                <td>
                  {{
                  item.fileCategory.code === "OTHER"
                  ? item.fileCategoryOtherName
                  ? item.fileCategoryOtherName
                  : item.fileCategory.name
                  : item.fileCategory.name
                  }}
                </td>
                <td>{{ item.fileSize / 1024 / 1024 | number: ".2" }} MB</td>
                <td>
                  <div class="d-flex flex-row align-items-center justify-content-center">
                    <div class="mx-1 padding0">
                      <span *ngIf="item.fileLocation" (click)="openDoc(item)">
                        <i class="pi pi-eye mr-1" pTooltip="View Document" tooltipPosition="top"></i>
                      </span>
                    </div>
                    <div class="mx-1 padding0">
                      <span (click)="deleteFiles(item)">
                        <i class="pi pi-trash mr-1" pTooltip="Delete Document" tooltipPosition="top"></i>
                      </span>
                    </div>
                    <div class="mx-1 padding0">
                      <button type="button" [disabled]="!(documentFileUploadConfigurations?.listUploadedFiles?.length)"
                        class="btn btn-primary px-2" (click)="convertUpload(item)">Extract Data</button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="pt-2 text-center"
          *ngIf="!documentFileUploadConfigurations?.listUploadedFiles || documentFileUploadConfigurations.listUploadedFiles.length === 0"
          style="margin-bottom: 40px">
          <h5>No Documents Uploaded</h5>
        </div>
      </div>
    </div>
  </div>
</div>